import {
  ComplaintsNotesDocument,
  ComplaintsNotesQuery,
  ComplaintsNotesQueryVariables,
} from 'generated/resources/graphql'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

import { DEFAULT_PAGINATED_CONNECTION } from 'modules/complaints/hooks/utils'

export type ComplaintNoteNodes = ComplaintsNotesQuery['complaints']['notesConnection']['edges']

export const useComplaintsNotes = (variables: ComplaintsNotesQueryVariables) => {
  const { nodes, controls } = usePaginatedQuery(ComplaintsNotesDocument, {
    variables,
    extractConnection: (dataToExtract) =>
      dataToExtract.complaints.notesConnection ?? DEFAULT_PAGINATED_CONNECTION,
  })

  return {
    notes: nodes,
    controls,
  }
}
